import React from 'react';

const FAQs = () => {
  return (
    <div className="page">
      <h1>FAQs</h1>
      <p>Find answers to common questions about our services.</p>
    </div>
  );
};

export default FAQs;